/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Per_YearInputs */

const en_plan_per_year = /** @type {(inputs: Plan_Per_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/year`)
};

const es_plan_per_year = /** @type {(inputs: Plan_Per_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/año`)
};

/**
* | output |
* | --- |
* | "/year" |
*
* @param {Plan_Per_YearInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_per_year = /** @type {((inputs?: Plan_Per_YearInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Per_YearInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_per_year(inputs)
	return en_plan_per_year(inputs)
});